const defaultAboutHeading = {
  text: '',
  highlight: '',
  subtitle: '',
  level: 2,
};

export function parseAboutFormFromRecord(record?: {
  aboutHeading?: {
    text?: string;
    highlight?: string;
    subtitle?: string;
    level?: number;
  };
  sectionHeadings?: {
    about?: {
      text?: string;
      highlight?: string;
      subtitle?: string;
      level?: number;
    };
    processSteps?: Record<string, unknown>;
    documents?: Record<string, unknown>;
    faqs?: Record<string, unknown>;
  };
  aboutBlocks?: Array<{
    type?: string;
    html?: string;
    heading?: string;
    question?: string;
    answer?: string;
    answerFormat?: string;
    checklistItems?: string[];
  }>;
  process?: string;
}) {
  const heading =
    record?.aboutHeading?.text
      ? record.aboutHeading
      : record?.sectionHeadings?.about || defaultAboutHeading;

  const blocks = Array.isArray(record?.aboutBlocks) ? record?.aboutBlocks ?? [] : [];

  return {
    aboutHeading: {
      text: heading.text || defaultAboutHeading.text,
      highlight: heading.highlight || defaultAboutHeading.highlight,
      subtitle: heading.subtitle || defaultAboutHeading.subtitle,
      level: heading.level || defaultAboutHeading.level,
    },
    aboutDescription: record?.process || '',
    aboutContentBlocks: blocks.length
      ? blocks.map((block, index) => ({
          sequence: index + 1,
          type: block.type === 'qa' ? 'qa' : 'paragraph',
          html: block.html || '',
          question: block.question || block.heading || '',
          answer: block.answer || '',
          answerFormat: block.answerFormat || 'html',
          checklistItems: block.checklistItems || [],
        }))
      : [],
  };
}

export function buildAboutBlocksFromForm(values: {
  aboutContentBlocks?: Array<{
    type?: string;
    html?: string;
    question?: string;
    answer?: string;
    answerFormat?: string;
    checklistItems?: string[];
  }>;
}) {
  const blocks: Array<{
    sequence: number;
    type: 'paragraph' | 'qa';
    html?: string;
    question?: string;
    answer?: string;
    answerFormat?: string;
    checklistItems?: string[];
  }> = [];

  let sequence = 1;

  (values.aboutContentBlocks || []).forEach((item) => {
    if (item?.type === 'paragraph') {
      if (!item.html?.trim()) {
        return;
      }

      blocks.push({
        sequence: sequence++,
        type: 'paragraph',
        html: item.html,
      });
      return;
    }

    if (item?.type === 'qa' && item.question?.trim()) {
      blocks.push({
        sequence: sequence++,
        type: 'qa',
        question: item.question,
        answer: item.answer || '',
        answerFormat: item.answerFormat || 'html',
        checklistItems: (item.checklistItems || []).filter(Boolean),
      });
    }
  });

  return blocks;
}
